import React from 'react';
import { IframeVideo } from '~/common/VideoPlayer/IframeVideo';
import { HOSTNAME_PATHNAME_REGEX } from '~/utils/regex';

type PicTimeVideoProps = {
    isVideoControlsOn?: boolean;
    isLoopOn?: boolean;
    isAutoplayOn?: boolean;
    isTransparentBackgroundOn?: boolean;
    onError: () => void;
    onReady: () => void;
    videoLink: string;
};

export const PicTimeVideo = ({
    isVideoControlsOn,
    isTransparentBackgroundOn,
    isLoopOn,
    isAutoplayOn,
    onReady,
    onError,
    videoLink
}: PicTimeVideoProps) => {
    const matches = videoLink.match(HOSTNAME_PATHNAME_REGEX);

    const hostname = matches[1];
    const pathname = matches[2];
    if (!hostname || !pathname) {
        onError();
        return null;
    }

    const link = (() => {
        const picTimeParams = {
            controls: isVideoControlsOn ? 'visible' : 'hidden',
            transparentbg: isTransparentBackgroundOn,
            loop: isLoopOn,
            autoplay: isAutoplayOn,
            embedding: true
        };
        const picTimeQueryParams = new URLSearchParams();

        Object.entries(picTimeParams).forEach(([key, value]) =>
            picTimeQueryParams.append(key, value.toString())
        );
        return `https://${hostname}${pathname}?${picTimeQueryParams.toString()}`;
    })();

    return (
        <IframeVideo
            title="PicTime video"
            videoLink={link}
            onError={onError}
            onReady={onReady}
        />
    );
};
